import image1 from "../../common/images/products/1.jpg";
import image2 from "../../common/images/products/2.jpg";
import image3 from "../../common/images/products/3.jpg";
import image4 from "../../common/images/products/4.jpg";
import image5 from "../../common/images/products/5.jpg";
import image6 from "../../common/images/products/6.jpg";
import image7 from "../../common/images/products/7.jpg";
import image8 from "../../common/images/products/8.jpg";
import image9 from "../../common/images/products/9.jpg";
import image10 from "../../common/images/products/10.jpg";
import image11 from "../../common/images/products/11.jpg";
import image12 from "../../common/images/products/12.jpg";
import image13 from "../../common/images/products/13.jpg";
import image14 from "../../common/images/products/14.jpg";
import image15 from "../../common/images/products/15.jpg";
import image16 from "../../common/images/products/16.jpg";
import image17 from "../../common/images/products/17.jpg";

export const images = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
];
